<template>
    <div class="bg-blue-dark text-white-light">
        <div class="container mx-auto py-16">
            <div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-12 gap-8">
                <div class="col-span-2 md:col-span-2 lg:col-span-4">
                    <router-link ref="logo" to="/" class="block w-[110px] md:w-[150px] shrink-0">
                        <!-- Ususal Logo-->
                        <img v-if="region === 'de'" class="w-full h-auto" :src="$asset('/hkcm/images/logo-on-dark-background.svg', 'public')" alt="HKCM Logo" title="HKCM Logo" />
                        <!--  GLOBAL LOGO-->
                        <img v-else class="w-full h-auto" :src="$asset('/hkcm/images/logo-hkcm-global_2_light.svg', 'public')" alt="HKCM Global Logo" title="HKCM Logo" />
                    </router-link>
                    <div class="mt-4" v-html="$translate(settings.company_address)" />
                    <div class="mt-4" v-html="$translate(settings.company_contact)" />
                    <div class="mt-4">
                        <p>
                            {{ $t('homepage_cooperation') }}
                        </p>
                        <div class="flex flex-col lg:flex-row gap-6 lg:items-center mt-4">
                            <img alt="Thomson Reuters" class="h-8 w-full object-contain object-left" :src="$asset('/hkcm/images/partners/thomson-reuters-white.png', 'public')" />
                            <img alt="SUP Global" class="h-6 w-full object-contain object-left" :src="$asset('/hkcm/images/partners/sup-global-white.png', 'public')" />
                        </div>
                    </div>
                </div>

                <div class="col-span-2 hidden md:block lg:hidden">
                    <div class="flex flex-row gap-4 justify-end">
                        <a v-for="item in social_media" v-show="item.url" target="_blank" :alt="item.title" :title="item.title" :url="item.url">
                            <i :class="item.icon" />
                        </a>
                    </div>
                </div>

                <div ref="menu_1" class="col-span-1 md:col-span-2 lg:col-span-2">
                    <strong>
                        {{ menu_1.name }}
                    </strong>
                    <ul class="mt-4">
                        <li v-for="menu_entry in menu_1.entries" :key="menu_entry.url" class="mb-2">
                            <router-link :title="menu_entry.title" :to="menu_entry.url" @click.prevent="jumpToFAQs">
                                {{ $t(menu_entry.name) }}
                            </router-link>
                        </li>
                        <li v-if="region === 'de'" class="mb-2">
                            <a target="_blank" title="Karriere" href="https://hopf-klinkmueller-capital-management.workwise.io/">
                                {{ $t('plain_career') }}
                            </a>
                        </li>
                    </ul>
                </div>
                <div ref="product_categories" class="col-span-1 md:col-span-2 lg:col-span-2">
                    <strong>
                        {{ $t('plain_products') }}
                    </strong>
                    <ul v-if="productCategories().length" class="mt-4">
                        <li
                            v-for="menu_entry in productCategories()"
                            :key="menu_entry.id"
                            class="mb-2 cursor-pointer"
                            @click="$router.push(`/produktkategorien/${menu_entry.slug.name}`)"
                        >
                            {{ $translate(menu_entry.name) }}
                        </li>
                    </ul>
                </div>
                <div class="col-span-2 md:col-span-3 lg:col-span-4 flex flex-col justify-between">
                    <div>
                        <strong> {{ $t('plain_newsletter') }} </strong>
                        <p class="mt-4">
                            {{ $t('footer_sign_up_newsletter') }}
                        </p>
                    </div>
                    <Newsletter placeholder="E-Mail *" />
                    <img
                        v-if="region === 'de'"
                        alt="DISQ Trust Siegel"
                        class="h-28 w-full object-contain object-left"
                        :src="$asset('/hkcm/images/partners/DISQTrust_Siegel_Von Kunden_Empfohlen_HKCM.png', 'public')"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="bg-white text-blue-dark">
        <div class="container mx-auto py-5">
            <div class="flex flex-col lg:flex-row gap-4 lg:gap-8 lg:justify-between items-center">
                <div class="flex flex-row gap-4 items-center">
                    <a href="https://apps.apple.com/de/app/hkcm/id6499010943" class="h-auto" target="_blank">
                        <img
                            alt="Apple Store"
                            class="object-contain max-h-[30px]"
                            :src="$asset(i18next().language === 'de' ? '/hkcm/images/apple-store-badge.png' : '/hkcm/images/apple-store-badge-en.png', 'public')"
                        />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=de.hkcm.app&hl=de&pli=1" class="h-auto" target="_blank">
                        <img
                            alt="Google Play Store"
                            class="object-contain max-h-[30px]"
                            :src="$asset(i18next().language === 'de' ? '/hkcm/images/google-play-badge.png' : '/hkcm/images/google-play-badge-en.png', 'public')"
                        />
                    </a>
                </div>

                <div class="flex md:hidden lg:flex flex-row gap-4">
                    <a v-for="item in social_media" v-show="item.url" target="_blank" :href="item.url">
                        <i class="lg:block hidden" :class="item.icon" />
                        <i class="lg:hidden block text-4xl" :class="item.icon" />
                    </a>
                </div>

                <div class="flex flex-col md:flex-row">
                    <div class="w-full">
                        <small class="whitespace-nowrap"> © {{ new Date().getFullYear() }} {{ $t('plain_rights_reserved') }} </small>
                    </div>
                    <div class="flex flex-row justify-center md:justify-start">
                        <div v-for="item in footer" :key="item.name" class="footer-item">
                            <router-link :title="$t(item.title)" :to="item.url" class="text-xs font-light whitespace-nowrap">
                                {{ $t(item.name) }}
                            </router-link>
                        </div>
                    </div>
                </div>

                <div class="flex flex-row gap-4">
                    <img alt="Mastercard" class="h-10 w-auto" :src="$asset('/hkcm/images/payment-methods/mastercard.svg', 'public')" />
                    <img alt="Visa" class="h-10 w-auto" :src="$asset('/hkcm/images/payment-methods/visa.svg', 'public')" />
                    <img alt="PayPal" class="h-10 w-auto" :src="$asset('/hkcm/images/payment-methods/paypal.svg', 'public')" />
                    <img alt="ApplePay" class="h-10 w-auto" :src="$asset('/hkcm/images/payment-methods/applepay.svg', 'public')" />
                    <img alt="GooglePay" class="h-10 w-auto" :src="$asset('/hkcm/images/payment-methods/googlepay.svg', 'public')" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import i18next from 'i18next';
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters('settings', {
            settings: 'get'
        }),
        ...mapGetters('product_categories', {
            productCategories: 'get'
        }),
        region() {
            return window.meta?.region_configuration?.region || 'de';
        },
        social_media() {
            return [
                {
                    icon: 'fi fi-brands-facebook',
                    url: this.region === 'de' ? 'https://www.facebook.com/Hopf-Klinkm%C3%BCller-Capital-Management-102656601911927/' : null,
                    title: 'Facebook'
                },
                {
                    icon: 'fi fi-brands-twitter-alt-square',
                    url: this.region === 'de' ? 'https://twitter.com/HKCM1' : 'https://twitter.com/hkcm_global',
                    title: 'X/Twitter'
                },
                {
                    icon: 'fi fi-brands-tik-tok',
                    url: this.region === 'de' ? 'https://www.tiktok.com/@hkcmanagement' : null,
                    title: 'TikTok'
                },
                {
                    icon: 'fi fi-brands-instagram',
                    url: this.region === 'de' ? 'https://www.instagram.com/hkc_management/' : 'https://www.instagram.com/hkcm_global/',
                    title: 'Instagram'
                },
                {
                    icon: 'fi fi-brands-youtube',
                    url: this.region === 'de' ? 'https://www.youtube.com/c/HopfKlinkm%C3%BCllerCapitalManagement' : 'https://www.youtube.com/@HKCM_GLOBAL',
                    title: 'Youtube'
                },
                {
                    icon: 'fi fi-brands-linkedin',
                    url: this.region === 'de' ? 'https://www.linkedin.com/company/hopf-klinkm%C3%BCller-capital-management/' : null,
                    title: 'LinkedIn'
                }
            ];
        }
    },

    data: () => ({
        menu_1: {
            name: 'HKCM',
            entries: [
                {
                    name: 'nav_our_charts',
                    url: '/charts',
                    title: 'nav_our_charts'
                },
                {
                    name: 'nav_faq',
                    url: '/howto#faqs',
                    title: 'FAQs'
                },

                {
                    name: 'nav_our_team',
                    url: '/aboutus',
                    title: 'nav_our_team'
                },
                {
                    name: 'nav_contact',
                    url: '/kontakt',
                    title: 'nav_contact'
                },
                {
                    name: 'nav_antiscam',
                    url: '/antiscam',
                    title: 'antiscam'
                }
            ]
        },
        footer: [
            {
                name: 'plain_imprint',
                url: '/impressum',
                title: 'plain_imprint'
            },
            {
                name: 'plain_privacy',
                url: '/datenschutz',
                title: 'plain_privacy'
            },
            {
                name: 'plain_terms',
                url: '/agb',
                title: 'plain_terms'
            }
        ]
    }),

    methods: {
        jumpToFAQs() {
            document.getElementById('faqs').scrollIntoView({
                behavior: 'smooth'
            });
        },
        i18next() {
            return i18next;
        }
    }
};
</script>

<style scoped>
.footer-item:before {
    content: '•';
    margin-right: 10px;
    margin-left: 10px;
}
</style>
